<template>
  <div class="info">
    <div class="content">
      <div class="form">
        <div class="userinfo">
          你好，{{ getUserInfo.username }}
        </div>
        <div class="tip" v-if="getUserInfo.express === 0 && isSubmit === false && awardInfo.award_title != '参与奖' ">
          请您认真填写如下信息，我的的工作人员会通过或者手机短信/微信与您取得联系，将奖品“当当V卡的卡密信息”一对一发送给您，获奖人需要通过邮件或短信/微信回复奖品收到的确认信息后，完成收奖流程
          <div>
            我们工作人员的邮箱为：zhengji@chineseplus.net；QQ号码：2151697624
          </div>
          <div>
            以下信息仅供认证获奖人身份及邮寄奖品使用，我们会严格保护您的信息安全，请安心填写。
          </div>
        </div>
        <div class="tip" v-if="(getUserInfo.express === 1 || isSubmit === true) && awardInfo.award_title != '参与奖'">
          您的邮寄地址信息已提交成功，请您耐心等待，我们将为您邮寄礼品，如有任何问题，请您联系我们的官方邮箱：zhengji@chineseplus.net
        </div>
        <el-form :model="formData" :rules="rules" ref="formData" label-position="left" class="formCon"
          v-if="getUserInfo.express === 0 && isSubmit === false && awardInfo.award_title != '参与奖'">
          <!-- <el-form-item label="领奖方式"  prop="receive_type">
              <el-radio-group v-model="formData.receive_type">
                <el-radio  label="1">本人领奖</el-radio>
                <el-radio  label="2">他人领奖</el-radio>
              </el-radio-group>
            </el-form-item> -->
          <el-form-item label="领奖人姓名" prop="express_username">
            <el-input v-model="formData.express_username" placeholder="" style="width: 270px;"></el-input>
          </el-form-item>
          <el-form-item label="领奖人国内电话号码" prop="express_tel">
            <el-input v-model="formData.express_tel" placeholder="" style="width: 270px;"></el-input>
          </el-form-item>
          <el-form-item label="领奖人邮箱" prop="express_email">
            <el-input v-model="formData.express_email" style="width: 270px;"></el-input>
          </el-form-item>
          <el-form-item label="领奖人微信号" prop="express_wechat">
            <el-input v-model="formData.express_wechat" style="width: 270px;"></el-input>
          </el-form-item>
          <el-form-item label="领奖人身份证或护照号码" prop="express_id_card">
            <el-input v-model="formData.express_id_card" style="width: 270px;"></el-input>
          </el-form-item>
          <el-button type="primary" style="width: 100px;font-size:18px;" @click="submitForm()">提交</el-button>
        </el-form>

      </div>
      <img src="../img/line.png" alt="" class="infoLine" v-if="awardInfo.award_title">
      <div class="awardInfo">
        <img src="../img/card.png" alt="" class="card" v-if="awardInfo.award_title">
        <div class="award" v-if="awardInfo.award_title">
          <div v-if="awardInfo.award_title === '参与奖'">
            <div class="awardImage_1">
              <el-image :src="awardInfo.image_url" class="cover" v-if="awardInfo.image_url" fit="cover"></el-image>
              <div class="downlode">
                  <img src="../img/Vcard/download.png" alt="" class="down" @click="downloadPic(awardInfo.image_url)">
              </div>
            </div>
          </div>
          <div v-else class="">
            <div class="work">
              <el-image :src="'https://collection2021-cos.chineseplus.net/' + awardInfo.video_cover" class="cover"
                fit="cover" v-if="awardInfo.type == 1 && awardInfo.video_cover"></el-image>
              <div class="type">
                {{ awardInfo.award_title }}
                <span v-if="awardInfo.type == 1">短视频类</span>
                <span v-if="awardInfo.type == 2">图片故事类</span>
              </div>
              <div class="title">
                {{ awardInfo.works_title }}
              </div>
            </div>
            <div class="awardImage">
              <el-image :src="awardInfo.image_url" class="cover" v-if="awardInfo.image_url" fit="cover"></el-image>
              <div class="downlode">
                <img src="../img/Vcard/download.png" alt="" class="down" @click="downloadPic(awardInfo.image_url)">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'notice',
  data: function () {

    var checkPhone = (rule, value, callback) => {//手机号码校验
      const phoneReg = /^1[3|4|5|7|8|9][0-9]{9}$/
      if (!value) {
        return callback(new Error('电话号码不能为空'))
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'))
        } else {
          if (phoneReg.test(value)) {
            callback()
          } else {
            callback(new Error('电话号码格式不正确'))
          }
        }
      }, 100)
    }
    var checkEmail = (rule, value, callback) => {//邮箱校验
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的邮箱格式'))
        }
      }, 100)
    }
    return {
      awardInfo: {},
      isSubmit: false,
      formData: {
        express_username: '',
        express_email: '',
        express_wechat: '',
        express_tel: '',
        express_id_card: ''
      },
      rules: {
        express_username: [
          { required: true, message: '请输入领奖人姓名', trigger: 'blur' },
        ],
        express_email: [
          { validator: checkEmail, required: true, trigger: 'blur' },
        ],
        express_wechat: [
          { required: true, message: '请输入领奖人微信号', trigger: 'blur' },
        ],
        express_tel: [
          { validator: checkPhone, required: true, trigger: 'blur' },
        ],
        express_id_card: [
          { required: true, message: '请输入领奖人身份证或护照号码', trigger: 'blur' },
        ],
      }
    }
  },
  computed: {
    ...mapGetters(['getUserInfo']),
  },
  mounted() {
    //判断用户权限
    this.checkUser()

    this.getAwardInfo()
  },
  methods: {
    //判断用户
    checkUser() {
      console.log(this.getUserInfo)
      if ( this.getUserInfo.have_award != 1 ) {
        this.$message({
          message: '您未获奖，无权限访问',
          type: 'warning'
        });
        //返回首页
        this.$router.push('/pcpage/home');
      }
    },

    // 获得获奖信息
    getAwardInfo() {
      this.$utils.get('/user/api/get-my-award').then(res => {
        if (res.code === 1002) {
          this.$message({
            message: '请登录',
            type: 'warning'
          });
          this.loginFun()
        } else if (res.code == 1000) {
          this.awardInfo = res.data
        }
      })
    },
    submitForm() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          this.$utils.postForm('/user/express-info', this.formData).then(res => {
            if (res.code == 1000) {
              this.$message({
                message: '提交完成！',
                type: 'success'
              });
              this.isSubmit = true
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
          })
        } else {
          return false
        }
      })
    },
    // 登录
    loginFun() {
      const currentUrl = window.location.href
      window.location.href = 'https://collection2021.chineseplus.net/user/login?callback=' + encodeURIComponent(currentUrl)
    },
    routerTo(path) {
      this.$router.push(path)
    },
    //下载获奖证书
    downloadPic(imgsrc, name) {
      console.log('下载证书', imgsrc);
      // 下载图片地址和图片名
      var image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
        const canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        const context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        const url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
        const a = document.createElement('a') // 生成一个a元素
        const event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || '获奖证书' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.info {
  width: 1200px;
  margin: 80px auto 50px;
  text-align: center;
  font-size: 20px;
  text-align: left;

  .content {
    width: 1200px;
    background-color: #fff;
    padding: 44px 40px 70px;
    text-align: center;
    margin-top: 40px;
    box-sizing: border-box;

    .form::v-deep {
      width: 730px;
      margin: auto;
      text-align: left;

      .userinfo {
        font-family: MicrosoftYaHei-Bold;
        font-size: 50px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #c63416;
      }

      .formCon {
        text-align: left;
        margin-top: 20px;
      }

      .el-form-item__label {
        width: 180px !important;
      }

    }

    .infoLine {
      width: 1086px;
    }

    .card {
      margin-top: 60px;
      margin-bottom: 40px;
    }

    .award {
      margin: 0 10px;
      position: relative;

      .awardImage_1 {
        .cover {
          width: 509px;
        }
        .downlode {
            position: absolute;
            width: 509px;
            height: 100%;
            top: 0;
            left: 296px;
            background-color: rgba(0, 0, 0, .2);
            opacity: 0;
            transition: all .2s linear;

            &:hover {
              opacity: 1;
            }

            .down {
              position: absolute;
              top: 45%;
              left: 44%;
              width: 65px;
            }
          }
      }

      .work {
        text-align: left;

        .cover {
          display: block;
          width: 600px;
          height: 376px;
        }

        .type {
          display: inline-block;
          background-color: #f64109;
          border-radius: 10px;
          height: 25px;
          line-height: 25px;
          padding: 0 8px;
          margin-top: 15px;
          font-family: MicrosoftYaHei;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #ffffff;
        }

        .title {
          width: 480px;
          margin-top: 15px;
          font-size: 30px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: 0px;
          color: #282828;
        }
      }

      .awardImage {
        position: absolute;
        left: 495px;
        top: 100px;
        width: 509px;
        height: 360px;
        box-shadow: 0px 0px 10px 0px rgba(31, 16, 138, 0.11);
        border: solid 1px rgba(0, 0, 0, 0.17);

        .downlode {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background-color: rgba(0, 0, 0, .2);
          opacity: 0;
          transition: all .2s linear;

          &:hover {
            opacity: 1;
          }

          .down {
            position: absolute;
            top: 45%;
            left: 44%;
            width: 65px;
          }
        }

      }
    }

    .tip {
      font-size: 14px;
      color: #000;
      margin-top: 26px;
      line-height: 1.2;

      div {
        color: #999;
        margin-top: 10px;
      }
    }
  }
}
</style>